// REACT & REACT HOOKS
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// STORE ACTIONS
import {editProfile, getCurrentUser} from "store/actions";

// COMPONENTS
import Loader from "components/shared/loader";
import ImageUpload from "components/Form/image-upload";
import Form from "components/Form";
import FormWrapper from "components/Form/form-wrapper";
import Input from "components/Form/input";
import SaveChangesButton from "components/Form/save-changes-button";

// HELPERS
import {cutImageFullPath} from "helpers/functions";

const ViewEditProfile = () => {
    const dispatch = useDispatch();

    const {
        authentication: {user, loading},
    } = useSelector((state) => state);

    const [selectedImage, setSelectedImage] = useState({});

    useEffect(() => {
        dispatch(getCurrentUser());
        setSelectedImage({path: user.image});
    }, [dispatch]);

    const defaultValues = {
        name: user?.name,
        email: user?.email,
        phone: user?.phone,
    };

    const onSubmit = (data) => {
        if (data?.email === user?.email) delete data.email;
        if (data?.phone === user?.phone) delete data.phone;

        data.image = cutImageFullPath(selectedImage?.path);

        dispatch(editProfile({data}));
    };

    if (loading) return <Loader />;

    return (
        <FormWrapper title="editProfile" lg={12}>
            <Form onSubmit={onSubmit} defaultValues={defaultValues}>
                <ImageUpload
                    selectedImage={selectedImage}
                    setSelectedImage={setSelectedImage}
                />
                <Input name="name" />
                <Input type="number" name="phone" />
                <Input type="email" name="email" />

                <SaveChangesButton />
            </Form>
        </FormWrapper>
    );
};

export default ViewEditProfile;
